
import './App.css';
import './index.css';
import { ToastContainer , toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
// import Home from "./pages/Home"

// export default function App() {
//   return <Home />
// }

import { Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Pricing from "./pages/Pricing";
import Features from "./pages/Features";
import Solutions from "./pages/Solutions";
import About from "./pages/About";
import Roi from "./pages/ROI-Calculator";
import ContactUs from './pages/ContactUs';
import Career from './pages/Career';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';

export default function App() {
  return (
    <>
    <ToastContainer/>
      <div className="w-full max-w-9xl mx-auto px-4 sm:px-6 lg:px-8">
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/features" element={<Features />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/about" element={<About />} />
        <Route path="/roi" element={<Roi />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/careers" element={<Career />} />
        <Route path="/privacy" element={<PrivacyPolicy/>}/>
        <Route path="/terms" element={<TermsConditions/>}/>
      </Routes>
      </div>
    </>
  );
}
